import React, { Component } from "react";
import { get as _get, map as _map, isEqual as _isEqual, cloneDeep as _cloneDeep } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import MapDataWorld from "@highcharts/map-collection/custom/world.geo.json";
import Helmet from "react-helmet";

import { showAlertMessage, HighChart, Select, ErrorMessage, SingleDropzone } from "../../resusableComponents/common/formElements";

import { withRouter } from "../../resusableComponents/hoc/withRouter";
import DeleteSearchButton from "../../resusableComponents/common/dataSearchTable/components/DeleteSearchButton";
import ExportSearchButton from "../../resusableComponents/common/dataSearchTable/components/ExportSearchButton";
import DataSearchTable from "../../resusableComponents/common/dataSearchTable/components/DataSearchTable";
import SaveSearchModal from "../../resusableComponents/common/dataSearchTable/components/SaveSearchModal";
import EnrichButton from "../../resusableComponents/common/dataSearchTable/components/EnrichButton";
import Charts from "./components/Charts";

import { getDataSearchFilters, getDashboardCharts, getSearchData } from "../../redux/services/dataSearch";

import { updatePageLevelLoadingState } from "../../redux/actions/application";
import { thousandSeparator } from "../../helpers/utils";

class DataSearch extends Component {

  constructor(props) {
    super(props);

    this._mapRef = null;

    this.mapDefaultOptions = {
      chart: { height: 290, map: "custom/world" },
      tooltip: {
        headerFormat: "<span style=\"font-size: 10px\">{point.region}</span><br/>",
        formatter: function () {
          return `<b>${this.point.region}</b>: ${thousandSeparator(this.point.total)}`;
        }
      }, title: { text: null }, subtitle: { text: null }, exporting: { enabled: true },
      colors: ["#2caffe", "#fe6a35", "#d568fb", "#2ee0ca", "#fa4b42", "#6b8abc", "#544fc5"],
      mapNavigation: { enabled: true, enableDoubleClickZoomTo: true },
      legend: { title: { text: "", style: { color: "black" } }, align: "left", verticalAlign: "bottom", floating: true, layout: "vertical", valueDecimals: 0, backgroundColor: "rgba(255, 255, 255, 0.85)", symbolRadius: 0, symbolHeight: 14 },
      colorAxis: { dataClasses: [{ to: 3, color: "#2caffe" }, { from: 3, to: 10, color: "#fe6a35" }, { from: 10, to: 30, color: "#d568fb" }, { from: 30, to: 100, color: "#2ee0ca" }, { from: 100, to: 300, color: "#fa4b42" }, { from: 300, to: 1000, color: "#6b8abc" }, { from: 1000, color: "#544fc5" }] },
      series: [{
        data: [], joinBy: ["iso-a2", "iso_2"], name: "Region", allAreas: true, states: { hover: { color: "#a4edba", borderColor: "gray" } }, dataLabels: {
          enabled: false,
          formatter: function () {
            return thousandSeparator(this.point.total);
          }
        }
      }],
      credits: { enabled: false }
    };

    this.defaultSearchDataPayload = {
      page_no: 1,
      page_size: 100
    };

    this.state = {
      defaultSearchDataPayload: { ...this.defaultSearchDataPayload },
      jobSeniorityOptions: [],
      selectedJobSeniority: [],
      industryOptions: [],
      selectedIndustry: [],
      regionCountryOptions: [],
      selectedRegionCountry: [],
      companySizeOptions: [],
      selectedCompanySize: [],
      revenueOptions: [],
      selectedRevenue: [],
      departmentOptions: [],
      selectedDepartment: [],
      dashboardCharts: {},
      searchData: {},
      formErrors: {},
      fileUploaded: false,
      uploadedFileName: "",
      uploadedFileURL: "",
      uploadedTalContactIds: [],
      selectedAllIds: false,
      selectedIds: [],
      refreshChartAndTable: false,
      locationMapOption: { ...this.mapDefaultOptions },
      activeRequestCount: 0,
      savedSearchId: null
    };
  }

  componentDidMount() {
    this._fetchFilters();
    this._handleSearch();
  }

  componentDidUpdate(prevProps, prevState) {

    if (
      !_isEqual(prevState.defaultSearchDataPayload, this.state.defaultSearchDataPayload) &&
      !_isEqual(_get(prevState, "defaultSearchDataPayload.page_no", 1), _get(this.state, "defaultSearchDataPayload.page_no", 1))
    ) {
      this._fetchSearchData();
    }

    if (!_isEqual(prevState.refreshChartAndTable, this.state.refreshChartAndTable) && (_get(this.state, "refreshChartAndTable", false) === true)) {
      this._handleSearch();
    }

    if (
      (!_isEqual(_get(prevState, "selectedJobSeniority", []), _get(this.state, "selectedJobSeniority", []))
        || !_isEqual(_get(prevState, "selectedIndustry", []), _get(this.state, "selectedIndustry", []))
        || !_isEqual(_get(prevState, "selectedRegionCountry", []), _get(this.state, "selectedRegionCountry", []))
        || !_isEqual(_get(prevState, "selectedCompanySize", []), _get(this.state, "selectedCompanySize", []))
        || !_isEqual(_get(prevState, "selectedRevenue", []), _get(this.state, "selectedRevenue", []))
        || !_isEqual(_get(prevState, "selectedDepartment", []), _get(this.state, "selectedDepartment", []))
        || !_isEqual(_get(prevState, "uploadedTalContactIds", []), _get(this.state, "uploadedTalContactIds", []))
        || !_isEqual(_get(prevState, "fileUploaded", false), _get(this.state, "fileUploaded", false))
        || !_isEqual(_get(prevState, "uploadedFileName", ""), _get(this.state, "uploadedFileName", ""))
      )
      && (_get(this.state, "savedSearchId", null) !== null)
    ) {
      this.setState({ savedSearchId: null });
    }
  }

  _incrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = (_get(prevState, "activeRequestCount", 0) + 1);
      if (nextCount === 1 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(true); }
      return { activeRequestCount: nextCount };
    });
  }

  _decrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = Math.max(0, _get(prevState, "activeRequestCount", 0) - 1);
      if (nextCount === 0 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(false); }
      return { activeRequestCount: nextCount };
    });
  }

  _fetchFilters = async () => {
    try {
      this._incrementLoader();

      const response = await getDataSearchFilters();

      if ((response.flag || false) === true) {
        this.setState({
          // jobTitleOptions: response.data.jobTitleOptions,
          jobSeniorityOptions: response.data.job_seniority,
          industryOptions: response.data.industry,
          regionCountryOptions: response.data.country,
          companySizeOptions: response.data.company_size,
          revenueOptions: response.data.revenue,
          departmentOptions: response.data.department
        });
      } else {
        if (_get(response, "statusCode", 400) !== 401) {
          showAlertMessage(_get(response, "message", "Something went wrong while fetching filters."));
        }
      }

    } catch (error) {
      if (_get(error, "statusCode", 400) !== 401) {
        showAlertMessage(_get(error, "message", "Something went wrong while fetching filters."));
      }

    } finally {
      this._decrementLoader();
    }
  }

  _handleResetFilters = () => {
    this.setState({
      defaultSearchDataPayload: { ...this.defaultSearchDataPayload },
      selectedJobSeniority: [],
      selectedIndustry: [],
      selectedRegionCountry: [],
      selectedCompanySize: [],
      selectedRevenue: [],
      selectedDepartment: [],
      formErrors: {},
      fileUploaded: false,
      uploadedFileName: "",
      uploadedFileURL: "",
      uploadedTalContactIds: [],
      selectedAllIds: false,
      savedSearchId: null,
      selectedIds: [],
      refreshChartAndTable: false,
      locationMapOption: { ...this.mapDefaultOptions },
    }, () => this._handleSearch());
  }

  _fetchDashboardCharts = async () => {
    const { defaultSearchDataPayload, selectedJobSeniority, selectedIndustry, selectedRegionCountry, selectedCompanySize, selectedRevenue, selectedDepartment, uploadedTalContactIds } = this.state;

    try {
      this._incrementLoader();

      const { page_no, page_size, ...defaultSearchDataWithoutPagination } = defaultSearchDataPayload;
      const chartsPayload = {
        ...defaultSearchDataWithoutPagination,
        job_title: [],
        job_seniority: _map(selectedJobSeniority || [], item => _get(item, "id", "")),
        country: _map(selectedRegionCountry || [], item => _get(item, "id", "")),
        company_size: _map(selectedCompanySize || [], item => _get(item, "id", "")),
        revenue: _map(selectedRevenue || [], item => _get(item, "id", "")),
        department: _map(selectedDepartment || [], item => _get(item, "id", "")),
        industry: _map(selectedIndustry || [], item => _get(item, "id", "")),
        tal_contact_ids: (uploadedTalContactIds || []),
      };

      const response = await getDashboardCharts(chartsPayload);

      if ((response.flag || false) === true) {

        const locationMapOption = {
          ...this.mapDefaultOptions,
          series: [{
            mapData: MapDataWorld,
            data: _cloneDeep(_get(response, "data.country", [])),
            joinBy: ["iso-a2", "iso_2"],
            name: "Region",
            allAreas: true,
            states: { hover: { color: "#a4edba", borderColor: "gray" } },
            "colorKey": "total",
            dataLabels: {
              enabled: true,
              formatter: function () {
                return thousandSeparator(this.point.total);
              }
            }
          }]
        };

        this.setState({ dashboardCharts: _get(response, "data", {}), locationMapOption: locationMapOption });
      } else {
        if (_get(response, "statusCode", 400) !== 401) {
          showAlertMessage(_get(response, "message", "Something went wrong while fetching search result data."));
        }
      }

    } catch (error) {
      if (_get(error, "statusCode", 400) !== 401) {
        showAlertMessage(_get(error, "message", "Something went wrong while fetching search result data."));
      }

    } finally {
      this._decrementLoader();
    }
  }

  _fetchSearchData = async () => {
    const { defaultSearchDataPayload, selectedJobSeniority, selectedIndustry, selectedRegionCountry, selectedCompanySize, selectedRevenue, selectedDepartment, uploadedTalContactIds } = this.state;

    try {
      this._incrementLoader();

      const payload = {
        ...defaultSearchDataPayload,
        job_title: [],
        job_seniority: _map(selectedJobSeniority || [], item => _get(item, "id", "")),
        country: _map(selectedRegionCountry || [], item => _get(item, "id", "")),
        company_size: _map(selectedCompanySize || [], item => _get(item, "id", "")),
        revenue: _map(selectedRevenue || [], item => _get(item, "id", "")),
        department: _map(selectedDepartment || [], item => _get(item, "id", "")),
        industry: _map(selectedIndustry || [], item => _get(item, "id", "")),
        tal_contact_ids: (uploadedTalContactIds || []),
      };

      const response = await getSearchData(payload);

      if ((response.flag || false) === true) {
        this.setState({ searchData: _get(response, "data", {}), refreshChartAndTable: false });
      } else {
        if (_get(response, "statusCode", 400) !== 401) {
          showAlertMessage(_get(response, "message", "Something went wrong while fetching search result data."));
        }
      }

    } catch (error) {
      if (_get(error, "statusCode", 400) !== 401) {
        showAlertMessage(_get(error, "message", "Something went wrong while fetching search result data."));
      }

    } finally {
      this._decrementLoader();
    }
  }

  _handleSearch = async () => {
    this._fetchDashboardCharts();
    this._fetchSearchData();
  }

  handlePaginationChange = (pageNo) => {
    const { defaultSearchDataPayload } = this.state;

    this.setState({ defaultSearchDataPayload: { ...defaultSearchDataPayload, page_no: pageNo } });
  }

  _renderFilter = () => {
    const { allowedUploadFiles, allowedUploadFilesLabel, intl } = this.props;
    const {
      departmentOptions, revenueOptions, companySizeOptions,
      jobSeniorityOptions, industryOptions, regionCountryOptions, selectedJobSeniority,
      uploadedTalContactIds, defaultSearchDataPayload, fileUploaded, savedSearchId, selectedIds,
      selectedIndustry, selectedRegionCountry, selectedCompanySize, selectedRevenue, selectedDepartment,
      uploadedFileName, uploadedFileURL, formErrors, searchData
    } = this.state;

    return (
      <div className="row gy-4 mt-0">
        <div className="col-lg-3">
          <Select
            placeholder={intl.formatMessage({ id: "placeholder.select", defaultMessage: "Select" })}
            options={jobSeniorityOptions}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            label={intl.formatMessage({ id: "dataSearch.job_seniority", defaultMessage: "Job Seniority" })}
            value={selectedJobSeniority}
            onChange={(value) => {
              this.setState({ selectedJobSeniority: value });
            }}
          />
          {_get(formErrors, "selectedJobSeniority", "") && <ErrorMessage message={_get(formErrors, "selectedJobSeniority", "")} />}
        </div>
        <div className="col-lg-3">
          <Select
            placeholder={intl.formatMessage({ id: "placeholder.select", defaultMessage: "Select" })}
            options={industryOptions}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            label={intl.formatMessage({ id: "dataSearch.industry", defaultMessage: "Industry" })}
            value={selectedIndustry}
            onChange={(value) => {
              this.setState({ selectedIndustry: value });
            }}
          />
          {_get(formErrors, "selectedIndustry", "") && <ErrorMessage message={_get(formErrors, "selectedIndustry", "")} />}
        </div>
        <div className="col-lg-3">
          <Select
            placeholder={intl.formatMessage({ id: "placeholder.select", defaultMessage: "Select" })}
            options={regionCountryOptions}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            label={intl.formatMessage({ id: "dataSearch.region_country", defaultMessage: "Region/Country" })}
            value={selectedRegionCountry}
            onChange={(value) => {
              this.setState({ selectedRegionCountry: value });
            }}
          />
          {_get(formErrors, "selectedRegionCountry", "") && <ErrorMessage message={_get(formErrors, "selectedRegionCountry", "")} />}
        </div>
        <div className="col-lg-3">
          <Select
            placeholder={intl.formatMessage({ id: "placeholder.select", defaultMessage: "Select" })}
            options={companySizeOptions}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            label={intl.formatMessage({ id: "dataSearch.company_size", defaultMessage: "Company Size" })}
            value={selectedCompanySize}
            onChange={(value) => {
              this.setState({ selectedCompanySize: value });
            }}
          />
          {_get(formErrors, "selectedCompanySize", "") && <ErrorMessage message={_get(formErrors, "selectedCompanySize", "")} />}
        </div>
        <div className="col-lg-3">
          <Select
            placeholder={intl.formatMessage({ id: "placeholder.select", defaultMessage: "Select" })}
            options={revenueOptions}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            label={intl.formatMessage({ id: "dataSearch.revenue", defaultMessage: "Revenue" })}
            value={selectedRevenue}
            onChange={(value) => {
              this.setState({ selectedRevenue: value });
            }}
          />
          {_get(formErrors, "selectedRevenue", "") && <ErrorMessage message={_get(formErrors, "selectedRevenue", "")} />}
        </div>
        <div className="col-lg-3">
          <Select
            placeholder={intl.formatMessage({ id: "placeholder.select", defaultMessage: "Select" })}
            options={departmentOptions}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            label={intl.formatMessage({ id: "dataSearch.department", defaultMessage: "Department" })}
            value={selectedDepartment}
            onChange={(value) => {
              this.setState({ selectedDepartment: value });
            }}
          />
          {_get(formErrors, "selectedDepartment", "") && <ErrorMessage message={_get(formErrors, "selectedDepartment", "")} />}
        </div>
        <div className="col-lg-6">
          <div className="card-file-upload">
            <div className="row">
              <div className="col-lg-12">
                <SingleDropzone
                  acceptedFormat={allowedUploadFiles}
                  allowedExtensions={allowedUploadFilesLabel}
                  setState={(args) => this.setState(args)}
                  source="account_list"
                  displayUploadedFiles={true}
                  displayUploadedRemoveBtn={true}
                  fileUploadLabel={intl.formatMessage({ id: "dataSearch.upload_tal", defaultMessage: "Upload TAL" })}
                  uploadedFileName={(uploadedFileName || "")}
                  uploadedFileURL={(uploadedFileURL || "")}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="d-flex flex-column flex-sm-row align-items-stretch justify-content-end flex-wrap gap-2 mb-3">
            <div className="d-flex flex-grow-1 flex-sm-grow-0 me-sm-auto">
              <SaveSearchModal
                selectedJobSeniority={(selectedJobSeniority || [])}
                selectedIndustry={(selectedIndustry || [])}
                selectedRegionCountry={(selectedRegionCountry || [])}
                selectedCompanySize={(selectedCompanySize || [])}
                selectedRevenue={(selectedRevenue || [])}
                selectedDepartment={(selectedDepartment || [])}
                uploadedTalContactIds={(uploadedTalContactIds || [])}
                defaultSearchDataPayload={(defaultSearchDataPayload || {})}
                fileUploaded={(fileUploaded || false)}
                uploadedFileName={(uploadedFileName || "")}
                uploadedFileURL={(uploadedFileURL || "")}
                savedSearchId={(savedSearchId || null)}
                selectedIds={(selectedIds || [])}
                onSuccess={(savedSearchId) => this.setState({ savedSearchId })}
              />
            </div>

            <div className="d-flex align-items-center justify-content-center flex-grow-1">
              <h5>
                <FormattedMessage id="data_search.table.showing_records" defaultMessage="Showing Records: {totalRecords}" values={{ totalRecords: thousandSeparator(_get(searchData, "page_info[0].total_records", 0)) }} />
              </h5>
            </div>
            <div className="d-flex flex-grow-1 flex-sm-grow-0">
              <button type="button" className="btn btn-primary waves-effect flex-fill text-capitalize" onClick={() => this._handleSearch()}>
                <FormattedMessage id="btn.search" defaultMessage="Search" />
              </button>
            </div>
            <div className="d-flex flex-grow-1 flex-sm-grow-0">
              <button type="button" className="btn btn-dark waves-effect flex-fill text-capitalize" onClick={() => this._handleResetFilters()}>
                <FormattedMessage id="btn.reset" defaultMessage="Reset" />
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderGraphSection = () => {
    const { dashboardCharts } = this.state;

    return (
      <div className="row gy-4 mt-0">
        <Charts title="Data Quality" chartData={_get(dashboardCharts, "data_quality", {})} />
        <Charts title="Job Seniority" chartData={_get(dashboardCharts, "job_seniority", {})} />
        <Charts title="Industry" chartData={_get(dashboardCharts, "industry", {})} />
        <Charts title="Company Size" chartData={_get(dashboardCharts, "company_size", {})} />
        <Charts title="Revenue" chartData={_get(dashboardCharts, "revenue", {})} />
        <Charts title="Department" chartData={_get(dashboardCharts, "department", {})} />
        {this._renderRegionChart()}
      </div>
    )
  }

  _renderRegionChart = () => {
    const { locationMapOption } = this.state;

    return (
      <div className="col-lg-12">
        <div className="card shadow-none">
          <div className="card-body">
            <div className="d-flex align-items-center gap-2 justify-content-between mb-4">
              <h6 className="heading-04 fw-semibold mb-8">
                <FormattedMessage id="dataSearch.region_country" defaultMessage="Region/Country" />
              </h6>
            </div>
            <div>
              <HighChart
                type="mapChart"
                options={_cloneDeep(locationMapOption || {})}
                getChartRef={(chart) => (this._mapRef = chart)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  _renderTableData = () => {
    const { searchData, savedSearchId, selectedAllIds, selectedIds, selectedJobSeniority, selectedIndustry, selectedRegionCountry, selectedCompanySize, selectedRevenue, selectedDepartment, uploadedTalContactIds, defaultSearchDataPayload, fileUploaded, uploadedFileName, uploadedFileURL } = this.state;

    return (
      <>
        <div className="row gy-4 mt-0">
          <div className="col-lg-12">
            <div className="card shadow-none">
              <div className="card-body">
                <div className="d-flex flex-column flex-sm-row align-items-stretch justify-content-between flex-wrap gap-2 mb-3">
                  <div className="d-flex flex-grow-1 flex-sm-grow-0">
                    <SaveSearchModal
                      selectedJobSeniority={(selectedJobSeniority || [])}
                      selectedIndustry={(selectedIndustry || [])}
                      selectedRegionCountry={(selectedRegionCountry || [])}
                      selectedCompanySize={(selectedCompanySize || [])}
                      selectedRevenue={(selectedRevenue || [])}
                      selectedDepartment={(selectedDepartment || [])}
                      uploadedTalContactIds={(uploadedTalContactIds || [])}
                      defaultSearchDataPayload={(defaultSearchDataPayload || {})}
                      fileUploaded={(fileUploaded || false)}
                      uploadedFileName={(uploadedFileName || "")}
                      uploadedFileURL={(uploadedFileURL || "")}
                      savedSearchId={(savedSearchId || null)}
                      selectedIds={(selectedIds || [])}
                      onSuccess={(savedSearchId) => this.setState({ savedSearchId })}
                    />
                  </div>
                  <div className="d-flex align-items-center justify-content-center flex-grow-1">
                    <h5>
                      <FormattedMessage id="data_search.table.showing_records" defaultMessage="Showing Records: {totalRecords}" values={{ totalRecords: thousandSeparator(_get(searchData, "page_info[0].total_records", 0)) }} />
                    </h5>
                  </div>
                  <div className="d-flex flex-grow-1 flex-sm-grow-0">
                    <ExportSearchButton
                      source="data_search"
                      selectedAllIds={(selectedAllIds || false)}
                      selectedIds={(selectedIds || [])}
                      selectedJobSeniority={(selectedJobSeniority || [])}
                      selectedIndustry={(selectedIndustry || [])}
                      selectedRegionCountry={(selectedRegionCountry || [])}
                      selectedCompanySize={(selectedCompanySize || [])}
                      selectedRevenue={(selectedRevenue || [])}
                      selectedDepartment={(selectedDepartment || [])}
                      uploadedTalContactIds={(uploadedTalContactIds || [])}
                      savedSearchId={(savedSearchId || null)}
                    />
                  </div>
                  <div className="d-flex flex-grow-1 flex-sm-grow-0">
                    <DeleteSearchButton
                      source="data_search"
                      selectedAllIds={(selectedAllIds || false)}
                      selectedIds={(selectedIds || [])}
                      selectedJobSeniority={(selectedJobSeniority || [])}
                      selectedIndustry={(selectedIndustry || [])}
                      selectedRegionCountry={(selectedRegionCountry || [])}
                      selectedCompanySize={(selectedCompanySize || [])}
                      selectedRevenue={(selectedRevenue || [])}
                      selectedDepartment={(selectedDepartment || [])}
                      uploadedTalContactIds={(uploadedTalContactIds || [])}
                      savedSearchId={(savedSearchId || null)}
                      setState={(args) => this.setState(args)}
                    />
                  </div>
                  <EnrichButton
                    savedSearchId={(savedSearchId || null)}
                    selectedIds={(selectedIds || [])}
                    selectedAllIds={(selectedAllIds || false)}
                  />
                </div>
                <DataSearchTable
                  searchData={(searchData || [])}
                  defaultSearchDataPayload={(defaultSearchDataPayload || {})}
                  onPageChange={(args) => this.handlePaginationChange(args)}
                  onSelectionChange={(selectedIds, selectedAllIds) => this.setState({ selectedIds, selectedAllIds })}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  render() {
    const { intl } = this.props;

    return (
      <>
        <Helmet>
          <title>
            {intl.formatMessage({ id: "olympus.data_search", defaultMessage: "Data Search: Olympus" })}
          </title>
        </Helmet>

        <div className="content-wrapper">
          <div className="container-fluid flex-grow-1 px-6 py-6">
            <div className="row gy-2">
              <div className="col-lg-12">
                <h1 className="heading-04 fw-semibold text-dark-35 text-uppercase">
                  <FormattedMessage id="data_search.title" defaultMessage="data search" />
                </h1>
              </div>
            </div>

            {this._renderFilter()}
            {this._renderGraphSection()}
            {this._renderTableData()}

          </div>
        </div>

      </>
    );
  }
}

const mapStateToProps = (state) => ({
  allowedUploadFiles: _get(state, "application.constants.allowedUploadFiles", ""),
  allowedUploadFilesLabel: _get(state, "application.constants.allowedUploadFilesLabel", ""),
});

const mapDispatchToProps = (dispatch) => ({
  updatePageLevelLoadingState: (data) => dispatch(updatePageLevelLoadingState(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(DataSearch)));
